import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-printable-walking',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['walking'],
	},
	landing: {
		ids: ['loader-walking-f', 'age-printable-walking-f'],
		route: {
			path: '/printable-walking-f',
			name: 'printable-walking-funnel',
		},
	},
	funnel: {
		id: 'ob-female-printable-walking',
		route: {
			path: '/printable-walking-f/ob/:page(.*)?',
			name: 'female-printable-walking',
		},
		slug: 'female-printable-walking',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-printable-walking-f',
	},
	upsell: {
		routeNames: ['upsell-activity-f'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
